const API_BASE_URL =
  import.meta.env["VITE_API_URL"] ||
  "https://us-central1-label-doctor-f255e.cloudfunctions.net/apiProxy";

export function emailDomain(email: string): string | null {
  const at = email.lastIndexOf("@");
  if (at <= 0 || at === email.length - 1) return null;
  return email.slice(at + 1).trim().toLowerCase() || null;
}

export async function fetchSsoProvider(params: { domain?: string; org?: string }): Promise<string | null> {
  if (Boolean(params.domain) === Boolean(params.org)) {
    throw new Error("SSO discovery requires exactly one of domain or org");
  }
  const qs = new URLSearchParams(
    Object.entries(params).filter((entry): entry is [string, string] => Boolean(entry[1])),
  ).toString();
  const res = await fetch(`${API_BASE_URL}/auth/sso-discovery?${qs}`);
  if (!res.ok) {
    throw new Error(`SSO discovery failed (${res.status})`);
  }
  const body = await res.json();
  if (body?.provider_id !== null && typeof body?.provider_id !== "string") {
    throw new Error("SSO discovery returned an invalid provider");
  }
  return body.provider_id;
}
